import React from 'react';
import { Divider, IconButton, InputAdornment } from '@material-ui/core';
import PropTypes from 'prop-types';
import EditFilled from '../../../icons/EditFilled';
import { efesGrayAlt, efesOrange } from '../../../theme';
import Check from '../../../icons/Check';
import Cancel from '../../../icons/Cancel';

import useStyles from './useStyles';

const EditableInputAdornment = (props) => {
  const { isDisabled, setIsEditable, setIsDefault, handleReset, handleCheck, handleCancel } = props;
  const classes = useStyles();

  return (
    <InputAdornment position="end">
      {isDisabled ? (
        <IconButton
          onClick={() => {
            setIsEditable(true);
            setIsDefault(false);
            handleReset();
          }}
        >
          <EditFilled color={efesGrayAlt} />
        </IconButton>
      ) : (
        <>
          <IconButton
            onClick={handleCheck}
          >
            <Check color={efesOrange} />
          </IconButton>
          <Divider orientation="vertical" flexItem className={classes.divider} />
          <IconButton
            onClick={() => {
              setIsEditable(false);
              setIsDefault(true);
              handleCancel();
            }}
          >
            <Cancel />
          </IconButton>
        </>
      )}
    </InputAdornment>
  );
};

EditableInputAdornment.propTypes = {
  isDisabled: PropTypes.bool.isRequired,
  setIsEditable: PropTypes.func.isRequired,
  setIsDefault: PropTypes.func.isRequired,
  handleReset: PropTypes.func.isRequired,
  handleCheck: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
};

export default EditableInputAdornment;
